module.exports = __webpack_public_path__ + "static/dominikawork2-9e84d345ff61f61dc13a9e655831d4ef.jpg";